import type { FaireProductEntity } from "../../entity_types/product";

export const p_89wx8z9m2j: FaireProductEntity = {
  token: "p_89wx8z9m2j",
  type: "product",
  name: "Little Dick's Habanero Peach Hot Sauce - Small Batch",
  brandToken: "b_q4s7hypqdn",
  brandName: "Little Dick's Sauces",
  imageUrl:
    "https://cdn.faire.com/fastly/de104335158f114b4d1b495cf5f6ee7ab7df0d29e7620b57ac7d8c736388e3bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98fe6ffe38f65034a34d94e5ddf2bb9600ae2e995d1c9bc265fe3116904eb4fd.jpeg",
    "https://cdn.faire.com/fastly/3d64b1eec6c59202dbf227dfd3cb0d9f258ae59289920d735f445bea84887b8b.jpeg",
    "https://cdn.faire.com/fastly/24fc10d75133fbcbb782b3239ef8f68804b14efcad4a6f8998b1d8187f286a1c.png",
    "https://cdn.faire.com/fastly/4d3291c7afa3f845e7fc56b429975d5d9102d1abfdc659595faa21be42ed6a83.jpeg",
    "https://cdn.faire.com/fastly/fe484344445fcf7eb42db12f14ba8531bfd32b5596912e237b873bd4f8a68f3b.jpeg",
    "https://cdn.faire.com/fastly/476618b2739cf96bcec79daef61b4fa06e26dd384f33f499520006dc6206b17d.jpeg",
    "https://cdn.faire.com/fastly/721f7809be00ea2341caf422124e8f8a64a64605fd521860d84cf3c20bd756e3.jpeg",
    "https://cdn.faire.com/fastly/95a9e3218109e45ee8bcf45902ed3f01463f6e0d8bac9de09d8b4daef08af0f7.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "🔥Featured in Hot Ones Subscription Box🔥\n\nHabanero Peach Hot Sauce – Sweet meets heat! Juicy peaches bring a burst of natural sweetness, perfectly balanced with a hint of smokiness and the bold kick of fiery habaneros. It’s smooth, spicy, and dangerously addictive. 🔥 Spice Level: 4/5\n\nSuggested pairings:  Our Habanero Peach sauce has been described as a spicy BBQ sauce and pairs great with steak, pork chops, chili, pasta & pizza. Try adding it to make a spicy Bloody Mary!\n\nBorn in NYC, Little Dick's hot sauces are prepared with all-natural ingredients that give you BIG FLAVOR and just enough heat to add some ZING to any dish. Try Little Dick's and you'll discover big things do come in small packages. Little Dick's. Big flavor!\n\n\n",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:25.287Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
